import { createStore } from 'vuex'
import request from '../utils/request'

export default createStore({
  state: {
    isAuthenticated: false,
    user: null,
    token: localStorage.getItem('token') || null
  },
  
  mutations: {
    setAuthentication(state, isAuthenticated) {
      state.isAuthenticated = isAuthenticated
    },
    setUser(state, user) {
      state.user = user
    },
    setToken(state, token) {
      state.token = token
    }
  },
  
  actions: {
    login({ commit }, credentials) {
      return new Promise((resolve, reject) => {
        // 实际项目中应该调用API
        request.post('/admin/auth/login', credentials)
          .then(response => {
            console.log('登录响应:', response); // request.js 已经解包了 response.data
            const { token, admin } = response.data;
            commit('setToken', token);
            commit('setUser', admin);
            commit('setAuthentication', true);
            localStorage.setItem('token', token);
            localStorage.setItem('user', JSON.stringify(admin));
            resolve(response);
          })
          .catch(error => {
            console.error('登录错误:', error); // 添加错误日志
            // 如果API不可用，使用模拟登录
            if (error.response && error.response.status === 404) {
              if (credentials.username === 'admin' && credentials.password === 'admin123') {
                const token = 'mock-jwt-token-' + Date.now();
                const user = {
                  id: 1,
                  username: 'admin',
                  realName: '系统管理员',
                  role: 'SUPER_ADMIN'
                };
                
                commit('setToken', token);
                commit('setUser', user);
                commit('setAuthentication', true);
                localStorage.setItem('token', token);
                localStorage.setItem('user', JSON.stringify(user));
                resolve({ data: { data: { token, admin: user } } });
              } else {
                reject(new Error('用户名或密码错误'));
              }
            } else {
              reject(error);
            }
          });
      });
    },
    
    logout({ commit }) {
      commit('setAuthentication', false)
      commit('setUser', null)
      commit('setToken', null)
      localStorage.removeItem('token')
      localStorage.removeItem('user')
    },
    
    // 初始化认证状态
    initAuth({ commit }) {
      const token = localStorage.getItem('token');
      const user = localStorage.getItem('user');
      
      if (token && user) {
        try {
          const userData = JSON.parse(user);
          commit('setToken', token);
          commit('setUser', userData);
          commit('setAuthentication', true);
        } catch (e) {
          // 清除无效数据
          localStorage.removeItem('token');
          localStorage.removeItem('user');
        }
      }
    }
  },
  
  getters: {
    isAuthenticated: state => state.isAuthenticated,
    currentUser: state => state.user,
    token: state => state.token
  }
})